import {getUserToken} from "../helpers/authHelpers";
import {API_BASE_URL} from "../config/api";

interface FetchParams {
  method: HttpMethod;
  endpoint: string;
  mode?: string;
  payload?: unknown;
}

interface BasicParams {
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  state: string;
}

export const fetchUser = async () => {
  try {
    return await fetchWithToken({
      method: "GET",
      endpoint: API_BASE_URL + "/oauth/client?client_id=untamed"
    });
  } catch (e) {
    console.log("Cannot reach API " + API_BASE_URL);
    return Promise.resolve(undefined);
  }
};

export const fetchOauthAuthorize = async <T>(
  params: BasicParams
): Promise<T> => {

  const {
    client_id,
    redirect_uri,
    response_type,
    scope,
    state
  } = params;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  var urlencoded = new URLSearchParams();
  urlencoded.append('client_id', client_id);
  urlencoded.append('redirect_uri', redirect_uri);
  urlencoded.append('response_type', response_type);
  urlencoded.append('scope', scope);
  urlencoded.append('state', state);

  return Promise.resolve(await fetchWithToken(
    {
      endpoint: API_BASE_URL + "/oauth/authorize?" + urlencoded,
      method: "GET",
      mode: "cors"
    }
  ));
};

export const fetchWithToken = async <T>(
  params: FetchParams,
  isRetry = false
): Promise<T> => {
  let currentToken = await getUserToken(isRetry);
  const {method, endpoint, payload} = params;
  const response = await fetch(endpoint, {
    credentials: "same-origin",
    method,
    body: payload ? JSON.stringify(payload) : null,
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${currentToken}`,
    }),
  });

  if (!response.ok && response.status !== 201) {
    if (response.status === 401 && !isRetry) {
      return fetchWithToken({method, endpoint, payload}, true);
    }
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }
  return response.json();
};